import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { map, take, tap } from 'rxjs'
import { Userpilot } from 'userpilot'

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.isAuthenticated$.pipe(
    take(1),
    tap(isAuthenticated => {
      if (isAuthenticated) {
        // Reload Userpilot on route change for SPA
        Userpilot.reload(state.url)
      } else {
        window.sessionStorage.setItem('redirect', state.url)
      }
    }),
    map(isAuthenticated =>
      isAuthenticated ? isAuthenticated : router.createUrlTree(['/', 'login'])
    )
  )
}
